<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">{{title}}</h4>
      </div>

      <div class="cell shrink">
        <a v-if="submitStatus === 'processing'" class="button primary transparent" style="color: #bbb; cursor: not-allowed;">Gå tilbake</a>
        <router-link v-else :to="{ name: 'ReportsList' }" class="button primary transparent" >Gå tilbake</router-link>
      </div>
    </div>

    <div class="content-container flex-row">
      <!-- <div class="sidebar left fixed subnav show-for-large">
        <div class="fixed-container">
          <ul>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'StatsSalgEksperter'}">Salg Eksperter</router-link>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'StatsSalgKategori'}">Salg Kategori</router-link>
            </li>
          </ul>
        </div>
      </div> -->

      <router-view v-on:onSubmitStatusChange="onSubmitStatusChange"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stats',
  data () {
    return {
      submitStatus: null
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Rapporter - Statistikk'
    }
  },
  methods: {
    onSubmitStatusChange: function (status) {
      this.submitStatus = status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Stats/Stats.vue